import EventBus from 'App/services/EventBus';
import logError from 'App/babel/helpers/logError';

// OAuthLanding records the failure on the far side of the provider's full page load, before the
// pill may have mounted, so it is kept for the tab as well as announced to a pill that is there.
const KEY = 'connectionProblemSignInFailed';
export const SIGN_IN_FAILED = 'connectionProblems.signInFailed';

export function setSignInFailed(integrationId: number | null) {
	try {
		if (integrationId === null) {
			window.sessionStorage.removeItem(KEY);
		} else {
			window.sessionStorage.setItem(KEY, String(integrationId));
		}
	} catch (error) {
		logError(error, 'ConnectionProblemPill: could not keep the failed sign-in for the tab');
	}
	EventBus.emit(SIGN_IN_FAILED, integrationId);
}

export function failedSignIn(): number | null {
	try {
		const value = window.sessionStorage.getItem(KEY);
		return value ? Number(value) : null;
	} catch (error) {
		logError(error, 'ConnectionProblemPill: could not read the failed sign-in');
		return null;
	}
}
